import { useEffect, useState } from "react";
import api from "@/lib/api";
import { portalApi } from "@/lib/PortalContext";

const cache = new Map();
const inFlight = new Map();

async function fetchAuthed(path) {
  if (cache.has(path)) return cache.get(path);
  if (inFlight.has(path)) return inFlight.get(path);
  const isPortal = typeof window !== "undefined" && window.location.pathname.startsWith("/portal");
  const isPublic = typeof window !== "undefined" && !window.location.pathname.startsWith("/portal")
                   && !isStudioPath(window.location.pathname);

  const tryUrls = isPortal
    ? [`/portal/files/${path}`]
    : isPublic
      ? [`/public/files/${path}`, `/files/${path}`]
      : [`/files/${path}`, `/portal/files/${path}`, `/public/files/${path}`];

  const p = (async () => {
    for (const url of tryUrls) {
      try {
        const client = url.startsWith("/portal/") ? portalApi : api;
        const res = await client.get(url, { responseType: "blob" });
        const blob = new Blob([res.data], { type: res.headers["content-type"] || "image/jpeg" });
        const objUrl = URL.createObjectURL(blob);
        cache.set(path, objUrl);
        return objUrl;
      } catch (_) { /* try next */ }
    }
    return null;
  })();
  inFlight.set(path, p);
  const r = await p;
  inFlight.delete(path);
  return r;
}

function isStudioPath(p) {
  return ["/dashboard", "/projects", "/leads", "/clients", "/products", "/suppliers", "/settings"]
    .some((x) => p === x || p.startsWith(x + "/"));
}

export function useAuthedFile(path) {
  const [url, setUrl] = useState(path && cache.get(path) ? cache.get(path) : null);
  useEffect(() => {
    if (!path) { setUrl(null); return; }
    let alive = true;
    fetchAuthed(path).then((u) => alive && setUrl(u));
    return () => { alive = false; };
  }, [path]);
  return url;
}

export function clearFileCache(path) {
  if (path && cache.has(path)) { URL.revokeObjectURL(cache.get(path)); cache.delete(path); }
}
